import { Injectable, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StateService } from '@uirouter/angular';
import { FrontEndService } from "./front-end.service";
import { LogService } from "app/services/log.service";
import { ConnectionService } from 'ng-connection-service';
import { DataService } from "./data.service";

@Injectable()
export class HttpCustomService {

    data = [];
    error_data = {};
    baseUrl = window['_env'].apiUrl;

    /**
     * Create authorization header for all http requests
     * @returns {Headers}
     */
    static createCommonAuthorizationHeader() {
        let headers = new HttpHeaders();
        const current_user = JSON.parse(localStorage.getItem('currentUser'));
        if (current_user != null ) {
            const storedToken = current_user.token_type + ' ' + current_user.token;
            headers = headers.append('Authorization', storedToken);
        }

        return headers
    }

    constructor(
        private http: HttpClient,
        private stateService: StateService,
        private frontEndService: FrontEndService,
        private logService: LogService,
        private connectionService: ConnectionService,
        private dataService: DataService
    ) {
        // Change to production url
        if (window['_env'].production) {
            const host = window.location.host.split(':')[0];
            const protocol = window.location.href.split(':')[0];
            this.baseUrl = protocol + '://'+ host +':8080/app/';
        }

        this.connectionService.monitor().subscribe(isConnected => {
            this.dataService.isConnected = isConnected;
        })
    }

    commonPopupCallBack(resp, url, body, callType) {
        const translateJson = this.frontEndService.en_json_data;

        let html = '';

        if (resp.hasOwnProperty('message') && typeof resp['message'] !== 'string') {
            for (const key in resp.message) {
                if (resp.message.hasOwnProperty(key)) {
                    for (let i = 0; i < resp.message[key].length; i++) {
                        if (resp.message[key][i] in translateJson) {
                            if (key in translateJson) {
                                html += translateJson[key] + ": " + translateJson[resp.message[key][i]] + "<br>";
                            } else {
                                html += key + ": " + translateJson[resp.message[key][i]] + "<br>";
                            }
                        } else {
                            if (key in translateJson) {
                                html += translateJson[key] + ": " + resp.message[key][i] + "<br>";
                            } else {
                                html += key + ": " + resp.message[key][i] + "<br>";
                            }
                        }
                    }
                }

                this.logService.printLog("html" + html);

                let header = "Error";
                if (resp.status) {
                    header = "Result Ok";
                }

                if (html !== '') {
                    this.frontEndService.showAlert(header, html);
                }
            }
        } else if (resp['data'] != null && resp['data'] instanceof Array && resp['data'].length > 0) {
            if (resp.hasOwnProperty('message') && resp['message'] !== "" && typeof resp.message === 'string') {
                html += translateJson[resp['message']] + "<br><br>";
            }

            resp['data'].forEach((data, index) => {
                if (data != null && data instanceof Array && data.length > 0) {
                    data.forEach((errorMessages, i) => {
                        this.logService.printLog("Error messages - ", errorMessages);
                        for (const key in errorMessages) {
                            if (errorMessages.hasOwnProperty(key)) {
                                let value = errorMessages[key];
                                let translatedKey = key;
                                if (value in translateJson) {
                                    value = translateJson[value];
                                }
                                if (key in translateJson) {
                                    translatedKey = translateJson[key];
                                }
                                html += translatedKey + ": " + value + "<br>";
                            }
                        }
                        if (i !== (data.length - 1) || index !== (resp['data'].length - 1)) {
                            html += "<hr />";
                        }
                    });
                } else if (data != null && data instanceof Object && Object.keys(data).length > 0) {
                    Object.keys(data).forEach((key, i) => {
                        if (i !== (data.length - 1) || index !== (resp['data'].length - 1)) {
                            html += "<hr />";
                        }

                        if (data.hasOwnProperty(key)) {
                            let value = data[key];
                            let translatedKey = key;
                            if (value in translateJson) {
                                value = translateJson[value];
                            }
                            if (key in translateJson) {
                                translatedKey = translateJson[key];
                            }
                            html += `${translateJson['row']} ${index + 1}: ` + translatedKey + ": " + value + "<br>";
                        }
                    });
                }
            });
            this.frontEndService.showAlert("Error", html)
        } else if (resp['data'] != null && resp['data'] instanceof Object && Object.keys(resp['data']).length > 0) {
            if (resp.hasOwnProperty('message') && resp['message'] !== "" && typeof resp.message === 'string') {
                let translatedMessage = resp['message'];
                if (translatedMessage in translateJson) {
                    translatedMessage = translateJson[translatedMessage];
                }
                html += translatedMessage + "<br><hr />";
            }

            for (const key in resp['data']) {
                if (resp['data'].hasOwnProperty(key)) {
                    const value = resp['data'][key];
                    let translatedKey = key;
                    let translatedValue = value;
                    if (value in translateJson) {
                        translatedValue = translateJson[value];
                    }
                    if (key in translateJson) {
                        translatedKey = translateJson[key];
                    }
                    html += translatedKey + ": " + translatedValue + "<br>";
                }
            }
            if (html !== "") {
                this.frontEndService.showAlert("Error", html)
            }
        } else if (resp.hasOwnProperty('message') && resp['message'] !== "" && typeof resp.message === 'string') {
            let header = "Error";
            if (this.dataService.isConnected) {
                if (resp.message in translateJson) {
                    html = translateJson[resp.message];
                } else {
                    html = resp.message;
                }

                if (resp['status']) {
                    header = "Result Ok";
                }
            } else {
                header = "Network Error";
                html = "Please check your internet connection";
            }

            if (html !== '') {
                this.frontEndService.showAlert(header, html);
            }
        } else {
            // Give auto feedback in case of server error
            if (("" + resp) !== "[object ProgressEvent]" && this.dataService.isConnected) {
                // this.frontEndService.showAlert("Server Error", "Please give feedback or contact administrator for more info.");
                this.frontEndService.customAlert("server_error", "please_report_error_or_contact_administrator_for_more_info", "warning", "report_error", "cancel", (result) => {
                    if (result.value) {
                        const feedback = {
                            "message": "Auto Generated Feedback for Server Error\n\n\n\n-------------------\n\n\n\nUrl - " + url + " -------------------\n\n\n\nBody - " + JSON.stringify(body, null, 2) + "-------------------\n\n\n\nCall type - " + callType + "-------------------\n\n\n\n" + resp,
                            "is_user_generated": 0
                        };

                        this.postData(feedback, "users/give_feedback/", () => {
                        });
                    }
                });
            } else {
                this.logService.printLog("Progress error", "logError");
            }
        }
    };

    handle_common_errors(
        error,
        callBack,
        url,
        body,
        callType
    ) {
        /**
         * This function will handle errors from any method.
         */
        this.logService.printError("Error - ", error);
        try {
            this.error_data = JSON.parse(error);
        } catch (exception) {
            this.error_data = error;
            this.logService.printError("Unable to parse json");
        }

        if (error['status'] === 401) {

            if(!localStorage.getItem('redirect_url') || localStorage.getItem('redirect_url') === '/login') {
                localStorage.setItem('redirect_url', window.location.pathname.toString());
            }

            const state_url = window.location.pathname.toString();

            if (
                state_url === "/login" ||
                state_url === "/signup" ||
                state_url === "/404" ||
                state_url === "/forgot-password"
            ) {
                // do nothing
            } else {
                this.stateService.go('login');
            }

        } else if (error['status'] === 403) {
            this.stateService.go('Forbidden');
        } else if (this.error_data['status'] === false) {
            if (this.error_data.hasOwnProperty('error')) {
                this.commonPopupCallBack(this.error_data['error'], url, body, callType);
            } else {
                this.commonPopupCallBack(this.error_data, url, body, callType);
            }
        } else {
            try {
                this.error_data = JSON.parse(this.error_data['_body']);
            } catch (exception) {
                if(this.error_data.hasOwnProperty('_body')) {
                    this.error_data = this.error_data['_body'];
                }
            }
            if (this.error_data.hasOwnProperty('error')) {
                this.commonPopupCallBack(this.error_data['error'], url, body, callType);
            } else {
                this.commonPopupCallBack(this.error_data, url, body, callType);
            }
        }

        this.error_data = [{
            'status': false
        }];

        if (callType === "get" || callType === "delete") {
            callBack(this.error_data[0]);
        } else {
            callBack(this.error_data[0]);
        }
        this.error_data = [];
    }

    handle_common_success(
        response,
        callBack
    ) {
        try {
            response = JSON.parse(response);
        } catch (Exception) {
            this.logService.printLog("Unable to parse json", 'logError');
        }
        callBack(response);
    }

    /**
     * DELETE Api Call
     * @param path - Url path of the api
     * @param callBack - Callback function
     */
    deleteData(
        path,
        callBack
    ) {
        const headers = HttpCustomService.createCommonAuthorizationHeader();
        return this.http.delete(this.baseUrl + path, { headers })
            .subscribe(
                (response) => {
                    this.handle_common_success(response, callBack);
                },
                (error) => {
                    this.handle_common_errors(error, callBack, this.baseUrl + path, "", "delete");
                },
                () => (this.data),
            );
    }

    /**
     * GET Api Call
     * @param path - Url path of the api
     * @param callBack - Callback function
     * @param download_files - Set true to download the file in case api returns a file
     */
    fetchData(
        path,
        callBack,
        download_files = false
    ) {
        // If call is to download files
        if (download_files) {
            const url =  this.baseUrl + path;

            // Save token of user.
            const current_user = JSON.parse(localStorage.getItem('currentUser'));
            if (current_user != null ) {
                // const storedToken = current_user.token_type + ' ' + current_user.token;
                let fileUrl = url;

                // Check if request already have parameters or not
                if (url.includes("?")) {
                    fileUrl += `&token=${current_user.token}`;
                } else {
                    fileUrl += `?token=${current_user.token}`;
                }

                window.open(fileUrl, "_blank");
                this.handle_common_success({status: true}, callBack);

            } else {
                this.handle_common_errors({status: 401, message: "User not authenticated."}, callBack, this.baseUrl + path, "", "get");
            }
        } else {
            const headers = HttpCustomService.createCommonAuthorizationHeader();

            return this.http.get(this.baseUrl + path, {headers})
                .subscribe(
                    (response) => {
                        this.handle_common_success(response, callBack);
                    },
                    (error) => {
                        this.handle_common_errors(error, callBack, this.baseUrl + path, "", "get");
                    },
                    () => (this.data),
                );
        }
    }

    /**
     * POST Api Call
     * @param jsonData - Payload
     * @param path - Url path of the api
     * @param callBack - Callback function
     * @param jsonToForm - Convert json to form
     */
    postData(
        jsonData,
        path,
        callBack,
        jsonToForm = false
    ) {
        // conversation json to form data
        if (jsonToForm === true) {
            const formData = new FormData();
            for (const k in jsonData ) {

                if (jsonData.hasOwnProperty(k)) {
                    if (k === "attached_file" || k === "backup_file" || k === "image" || k === "file") {
                        if (k !== "image" && k !== "file") {
                            for (let num = 0; num < jsonData[k].length; num++) {
                                formData.append(k, jsonData[k][num], jsonData[k][num].name);
                            }
                        } else {
                            formData.append(k, jsonData[k]);
                        }
                    } else {
                        formData.append(k, jsonData[k]);
                    }
                }
            }

            jsonData = formData;
        }

        const headers = HttpCustomService.createCommonAuthorizationHeader();

        return this.http.post(this.baseUrl + path, jsonData, { headers: headers })
            .subscribe(
                (response) => {
                    this.handle_common_success(response, callBack);
                },
                (error) => {
                    this.handle_common_errors(error, callBack, this.baseUrl + path, jsonData, "post");
                },
                () => (this.data),
            )
    }
}

